import { Button } from "@devhop/ui";
import { GripVertical, HelpCircle, PlusIcon } from "lucide-react";

type CategoriesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onReorder?: () => void;
  onStartTour?: () => void;
};

export function CategoriesToolbar({
  canManage,
  onCreate,
  onReorder,
  onStartTour,
}: CategoriesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">ຈັດການຫມວດຫມູ່ຟອມ</h2>
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={onStartTour}
              >
                <HelpCircle className="size-5" />
              </Button>
            )}
          </div>
          <p className="text-muted-foreground">
            ຈັດລຽງແລະຈັດໂຄງສ້າງຟອມພາຍໃນບໍລິສັດຕາມພະແນກແລະຫນ້າທີ່.
          </p>
        </div>
        <div className="flex items-center space-x-2">
          {onReorder && (
            <Button variant="outline" onClick={onReorder}>
              <GripVertical className="h-4 w-4" />
              ຈັດລຽງລາຍການ
            </Button>
          )}
          {canManage && (
            <div data-tourid="categories-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງຫມວດຫມູ່
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
